import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=31d1fd38&scoped=true&"
import script from "./Pending.vue?vue&type=script&lang=js&"
export * from "./Pending.vue?vue&type=script&lang=js&"
import style0 from "./Pending.vue?vue&type=style&index=0&id=31d1fd38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1fd38",
  null
  
)

export default component.exports